import { ChangeDetectorRef, Component, inject } from "@angular/core";
import {
  ProductFacade,
  SelectedProduct,
} from "../../../../services/product-facade";
import { DecimalMath } from "../../../../utils/utils";
import { BaseQtyItemComponent } from "../base-qty-item.component";
import { SVGIcon, chevronDownIcon } from "@progress/kendo-svg-icons";
import { UOM } from "../../../../models";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  RadioButtonDirective,
  NumericTextBoxComponent,
} from "@progress/kendo-angular-inputs";
import { DropDownListComponent } from "@progress/kendo-angular-dropdowns";
import { UpperCasePipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-fixed-item",
  templateUrl: "./fixed-item.component.html",
  styleUrls: ["../base-qty-item.component.scss"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RadioButtonDirective,
    NumericTextBoxComponent,
    DropDownListComponent,
    UpperCasePipe,
    TranslateModule,
  ],
})
export class FixedItemComponent extends BaseQtyItemComponent {
  override cdr: ChangeDetectorRef;
  override productFacade: ProductFacade;

  public chevronDown: SVGIcon = chevronDownIcon;

  constructor() {
    const cdr = inject(ChangeDetectorRef);
    const productFacade = inject(ProductFacade);

    super();

    this.cdr = cdr;
    this.productFacade = productFacade;
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override ngAfterViewInit(): void { 
    super.ngAfterViewInit();
    if (this.productFacade.isQuoteLineEditing &&
       !this.quoteLineDtl.quoteLineApplied &&
       this.lastSelectedLevel === this.quoteLineDtl.lastLevel &&
       this.part.qtyType === this.quoteLineDtl.qtyType) {      
      
      this.quoteLineDtl.quoteLineApplied = true;
      this.cdr.detectChanges();
    }
  }

  get visibleUOMs(): Array<UOM> {
    return this.part.partUOMs.filter((r) => r.visible == true);
  }

  setFormValues(r: SelectedProduct): void {
    this.qtyItemForm.controls.sellingUOM.setValue(r.sellingUOM, {
      emitEvent: false,
    });
    this.qtyItemForm.controls.sellingUOMDesc.setValue(r.sellingUOMDesc, {
      emitEvent: false,
    });
    this.qtyItemForm.controls.qty.setValue(r.qty);
  }

  computeTotalSellingQty(): number {
    const sellingUOM = this.part.partUOMs.find(
      (r) => r.uomCode === this.qtyItemForm.controls.sellingUOM.value,
    );
    const desiredQty = this.qtyItemForm.controls.qty.value;
    const factor = sellingUOM.convFactor;
    const sellingQty =
      (Math.ceil(Math.ceil(desiredQty * factor) / this.part.minLength) *
        this.part.minLength) /
      factor;
    let totalSellingQty: number;

    switch (sellingUOM.rounding) {
      case "RND":
        totalSellingQty = DecimalMath.round(sellingQty, sellingUOM.numOfDec);
        break;
      case "UP":
        totalSellingQty = DecimalMath.round(sellingQty, sellingUOM.numOfDec);
        break;
      case "DWN":
        totalSellingQty = DecimalMath.round(sellingQty, sellingUOM.numOfDec);
        break;
      default:
        totalSellingQty = DecimalMath.trunc(sellingQty, sellingUOM.numOfDec);
    }

    // Compute default uom qty
    if (sellingUOM.uomCode == this.part.defaultUOM) {
      this.qtyItemForm.controls.totalDefaultUOMQty.setValue(totalSellingQty);
    } else {
      const defaultUOM = this.part.partUOMs.find(
        (r) => r.uomCode === this.part.defaultUOM,
      );
      let totalDefaultUOMQty = totalSellingQty * sellingUOM.convFactor;

      switch (defaultUOM.rounding) {
        case "RND":
          totalDefaultUOMQty = DecimalMath.round(
            totalDefaultUOMQty,
            defaultUOM.numOfDec,
          );
          break;
        case "UP":
          totalDefaultUOMQty = DecimalMath.round(
            totalDefaultUOMQty,
            defaultUOM.numOfDec,
          );
          break;
        case "DWN":
          totalDefaultUOMQty = DecimalMath.round(
            totalDefaultUOMQty,
            defaultUOM.numOfDec,
          );
          break;
        default:
          totalDefaultUOMQty = DecimalMath.trunc(
            totalDefaultUOMQty,
            defaultUOM.numOfDec,
          );
      }
      this.qtyItemForm.controls.totalDefaultUOMQty.setValue(totalDefaultUOMQty);
    }

    return totalSellingQty;
  }
}
